module.exports = __webpack_public_path__ + "media/react/assets/images/background-image-a19b2772002bc647370fec1deab6465f.jpg";